import { Switch } from '@/components/shadcn/switch'
import { RestSchemas, useRestClient } from '@/contexts/QueryProvider'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { useCurrentWorkspace } from '../../useCurrentWorkspace'

type WorkspaceSchedule = RestSchemas['Messages.Scheduler.ExistingSchedule']

export function ScheduleEnabledSwitch({ schedule }: { schedule: WorkspaceSchedule }) {
  const { workspaceId } = useCurrentWorkspace()
  const { postSchedulerApiUpdateSchedule, getSchedulerApiGetSchedules } = useRestClient()
  const [enabled, setEnabled] = useState(schedule.enabled ?? false)

  useEffect(() => {
    setEnabled(schedule.enabled ?? false)
  }, [schedule.enabled])

  const { mutate: updateSchedule, isPending } = postSchedulerApiUpdateSchedule.useMutation()

  const handleCheckedChange = (checked: boolean) => {
    const previousEnabled = enabled
    setEnabled(checked)

    updateSchedule(
      {
        body: {
          ...schedule,
          workspaceId,
          enabled: checked,
        },
        path: {
          workspaceId,
          scheduleId: schedule.id,
        },
      },
      {
        onSuccess: () => {
          getSchedulerApiGetSchedules.invalidateQueries({
            parameters: {
              path: { workspaceId },
            },
          })
          toast.success(checked ? 'Schedule enabled' : 'Schedule disabled')
        },
        onError: () => {
          setEnabled(previousEnabled)
          toast.error('Failed to update schedule')
        },
      }
    )
  }

  return (
    <Switch
      checked={enabled}
      onCheckedChange={handleCheckedChange}
      disabled={isPending}
      aria-label={enabled ? 'Disable schedule' : 'Enable schedule'}
    />
  )
}
